import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./index.css";
// The legacy bootstrap/style/responsive stylesheets were only needed by the
// removed page chrome and are no longer imported.  The home page styles
// itself inline; the privacy policy page uses ./css/privacyPolicy.css
// scoped via the legal layout.
import App from "./App";
import { Provider } from "react-redux";
import configureStore from "./configureStore";
import * as serviceWorker from "./serviceWorker";
import { preloadedState } from "./preloadedState";

const store = configureStore(preloadedState);

class AppBootstrap extends Component {
    render() {
        return (
            <Provider store={store}>
                <App />
            </Provider>
        );
    }
}

ReactDOM.render(<AppBootstrap />, document.getElementById("root"));

serviceWorker.unregister();
